var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49998 0.583496C4.12998 0.583496 0.583313 4.13016 0.583313 8.50016C0.583313 12.8702 4.12998 16.4168 8.49998 16.4168C12.87 16.4168 16.4166 12.8702 16.4166 8.50016C16.4166 4.13016 12.87 0.583496 8.49998 0.583496ZM12.4583 9.29183H9.29165V12.4585H7.70831V9.29183H4.54165V7.7085H7.70831V4.54183H9.29165V7.7085H12.4583V9.29183Z",
    fill: "#4079F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2b34ed54bc7cd1077a5158d28b923794.svg";
export { ForwardRef as ReactComponent };